export enum DOCUMENT_STATUS_TYPES {
  'Pending' = 'Pending',
  'Submitted' = 'Submitted',
  'Prepared' = 'Prepared',
  'Notes Past due' = 'Notes Past due',
  'Report Past due' = 'Report Past due',
  'Completed' = 'Completed',
}